import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import ExpandIcon from '@material-ui/icons/KeyboardArrowDown';
import CollapseIcon from '@material-ui/icons/KeyboardArrowUp';

class CardBioContent extends Component {
  static propTypes = {
    info: PropTypes.shape({}),
    isCatalog: PropTypes.bool,
    noPadding: PropTypes.bool,
  };

  static defaultProps = {
    info: {},
    isCatalog: false,
    noPadding: false,
  };

  static contextTypes = {
    isFarmer: PropTypes.bool,
  };

  state = {
    showExtraBio: false,
  };

  handleShowExtraBio = () => {
    this.setState(state => ({ showExtraBio: !state.showExtraBio }));
  };

  render() {
    const {
      info,
      isCatalog,
      noPadding,
    } = this.props;
    const { isFarmer } = this.context;
    const { showExtraBio } = this.state;
    const isLongerThan500 = (get(info, 'bio') || '').length > 500;
    const bioComponent = (
      <Typography component="p">
        {info.bio || ''}
      </Typography>
    );

    return (
      <Fragment>
        {
          !isCatalog && !isFarmer && (
            <div className={`bio-collapse ${noPadding ? 'no-padding' : ''}`}>
              {
                info.bio && (
                  isLongerThan500 ? (
                    <Collapse
                      collapsedHeight="50px"
                      in={showExtraBio}
                    >
                      {bioComponent}
                    </Collapse>
                  ) : bioComponent
                )
              }
              {
                isLongerThan500 && (
                  <IconButton
                    aria-expanded={showExtraBio}
                    aria-label="Show more"
                    onClick={this.handleShowExtraBio}
                  >
                    {showExtraBio ? <CollapseIcon /> : <ExpandIcon />}
                  </IconButton>
                )
              }
            </div>
          )
        }
      </Fragment>
    );
  }
}

export default CardBioContent;
